module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.$store.state.user.nivel == 1) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/operacao/antecipacoes/nova"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Simular\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(item.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.qtd_boletos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.total_boletos, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.total_prorata, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.total_taxa_antecipacao, 2, ',', '.')))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")(item.total_antecipacao, 2, ',', '.')))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.situacao))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "title": "Visualizar"
      },
      on: {
        "click": function($event) {
          return _vm.getAntecipacao(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-file"
    })]), _vm._v(" "), (_vm.$store.state.user.nivel == 2 && item.situacao === 'EM ANÁLISE') ? _c('button', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "title": "Aprovar"
      },
      on: {
        "click": function($event) {
          return _vm.aprovaAntecipacao(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-thumbs-up"
    })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.nivel == 2 && item.situacao === 'EM ANÁLISE') ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Negar"
      },
      on: {
        "click": function($event) {
          return _vm.negaAntecipacao(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-thumbs-down"
    })]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.apiData.from) + " até " + _vm._s(this.apiData.to) + " de " + _vm._s(this.apiData.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.apiData
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Antecipação de Garantias")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Qtd. de Boletos")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Total Boletos")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Prorata")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Taxa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Total da Antecipação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "9%"
    }
  }, [_vm._v("Ação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a23e9ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operacao/antecipacao/index.vue
// module id = 388
// module chunks = 1